import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";
import Text from "components/atoms/Text";
import { Link } from "react-router-dom";
import Button from "components/atoms/Button";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  padding: 24px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
`;

const ContentBox = styled.div`
  background-color: white;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  text-align: center;
`;

const IconContainer = styled.div`
  margin-bottom: 24px;
  font-size: 64px;
  color: ${COLOR_SYSTEM.get("Red")?.[500]};
`;

const ButtonContainer = styled.div`
  margin-top: 24px;
`;

const Unauthorized: React.FC = () => {
  return (
    <Container>
      <ContentBox>
        <IconContainer>
          <span role="img" aria-label="금지 아이콘">
            ⛔
          </span>
        </IconContainer>
        <Text textType="H3" style={{ marginBottom: "16px" }}>
          접근 권한이 없습니다
        </Text>
        <Text textType="Body1" color={COLOR_SYSTEM.get("Gray")?.[600]}>
          이 페이지에 접근하기 위한 권한이 없습니다. 관리자 권한이 필요한 페이지입니다.
        </Text>
        <ButtonContainer>
          <Link to="/">
            <Button
              buttonType="button"
              type="Text"
              size="Medium"
              variant="Contained"
              color="Primary"
            >
              홈으로 돌아가기
            </Button>
          </Link>
        </ButtonContainer>
      </ContentBox>
    </Container>
  );
};

export default Unauthorized;
